import { useCallback } from "react";

import { useLocalStorage } from "@/hooks/useLocalStorage";

export interface RecentItem {
  id: string;
  type: "person" | "contribution" | "request" | "project";
  name: string;
  path: string;
  viewedAt: string;
}

export function useRecentlyViewed() {
  const [items, setItems] = useLocalStorage<RecentItem[]>("forge:recent", []);

  const addItem = useCallback(
    (item: Omit<RecentItem, "viewedAt">) => {
      setItems((prev) => {
        const filtered = prev.filter((existing) => existing.id !== item.id);
        return [
          { ...item, viewedAt: new Date().toISOString() },
          ...filtered,
        ].slice(0, 5);
      });
    },
    [setItems],
  );

  return { items, addItem };
}
